import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";

const initialPromotionsState = {
    entities: [],
    totalCount: null,
    listLoading: false,
    actionsLoading: false,
    message: {
        error: null,
        success: null,
        completed: null,
    },
    selectedPromotion: null,
    reset: false,
    insightsExportStatus: null,
    insightsExportURL: null,
};

export const callTypes = {
    list: "list",
    action: "action",
};

export const promotionsSlice = createSlice({
    name: "promotions",
    initialState: initialPromotionsState,
    reducers: {
        catchError: (state, action) => {
            let error =
                action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
            if (error.constructor.name === "Object") {
                let temp = [];
                for (let [k, v] of Object.entries(error)) {
                    temp.push(`${k}->${v}`);
                }
                error = temp;
            }
            state.message.error = error;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.message.success = null;
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // promotions fetched from api
        promotionsFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        promotionCreated: (state, action) => {
            const { message, entity } = action.payload;
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(entity);
            state.totalCount++;
            state.message.success = message;
        },
        promotionUpdated: (state, action) => {
            const { message, entity } = action.payload;
            state.actionsLoading = false;
            state.error = null;
            state.message.success = message;
            state.selectedPromotion = entity;

            const index = state.entities.findIndex(item => item.id === entity.id);
            if (index >= 0) {
                state.entities[index] = entity;
            } else {
                state.entities.push(entity);
                state.totalCount++;
            }
        },
        setSelectedPromotion: (state, action) => {
            const { entity } = action.payload;
            state.actionsLoading = false;
            state.error = null;
            state.selectedPromotion = entity;
        },
        resetSelectedPromotion: (state) => {
            state.selectedPromotion = null;
        },
        updateInsightsExportStatus: (state, action) => {
            const { status, url } = action.payload;
            state.insightsExportStatus = status;
            state.insightsExportURL = url;
        },
    },
});
